// extracted by mini-css-extract-plugin
module.exports =  {"close":"_35875ce240--close--OcT9C"};